<template>
  <page-listado>
    <page-header title="Contratos">
      <b-button variant="primary" size="sm" to="/contratos/crear" v-if="esAdmin">
        <v-icon name="plus" width="16"></v-icon>
        Crear contrato
      </b-button>
      <busqueda-rapida />
    </page-header>

    <filtros-contratos :filtros="$route.query" @filtrar="filtrar" />

    <tabla :contratos-clientes="resultado.contratosClientes" @eliminar="eliminar" @renovar="renovar" />
    <b-row class="mt-4">
      <b-col>
        <paginacion
          :page-count="parseInt(resultado.numeroPaginas)"
          :page="parseInt(resultado.pagina)"
          :total-items="parseInt(resultado.totalItems)"
        />
      </b-col>
    </b-row>
  </page-listado>
</template>

<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import contratosClienteApi from "@/services/contratosCliente.js";
import Tabla from "./TablaContratosCliente.vue";
import FiltrosContratos from "./FiltrosContratos.vue";
import EstadoContrato from "@/enums/EstadoContrato";

export default {
  components: { Tabla, FiltrosContratos },
  data() {
    return {
      resultado: {
        contratosClientes: [],
        numeroPaginas: 0,
        pagina: 1,
      },
    };
  },
  methods: {
    async listar() {
      if (typeof this.$route.query["estados"] == "undefined") {
        this.$route.query["estados"] = [EstadoContrato.PENDIENTE, EstadoContrato.ENPROCESO, EstadoContrato.INICIAL];
      }
      this.resultado = await contratosClienteApi.listar(this.$route.query);
    },
    async eliminar(id) {
      await contratosClienteApi.eliminar(id);
      this.listar();
    },
    async renovar(id) {
      var data = await contratosClienteApi.renovar(id);
      var ofertaId = data.data;
      this.$router.push("/ofertas/editar/" + ofertaId);
    },
    filtrar(data) {
      this.$router
        .push({
          path: this.$route.path,
          query: data,
        })
        .catch((err) => err);
    },
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
